import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/emailNotificationTemplatePreview', request)
}

export {get}
